import { ArticleItem } from '@/components/megamenu/ArticleItem';

export const MegaMenuNewsContent = ({ menuItems, popularBlogs, isLoading }) => {
  return (
    <div className="grid grid-cols-6 gap-2">
      {/* Left Section: Menu Items */}
      <div className="h-[460px] px-3 py-9 bg-[#fcfcff] col-span-3">
        <div className="h-[200px] gap-1">
          {menuItems.map((item, index) => (
            <a href={item.href}
              key={index}
              className="p-5 rounded-lg flex flex-col gap-2 hover:bg-[#F3F4F8] cursor-pointer"
            >
              <div className="flex items-center gap-2">
                <div className="w-6 h-6">{item.icon}</div>
                <div className="mega-menu-submenu-title">{item.title}</div>
              </div>
              <div className="mega-menu-submenu-text">{item.description}</div>
            </a>
          ))}
        </div>
      </div>

      {/* Right Section: Articles with Loading State */}
      <div className="h-[460px] px-6 py-8 bg-[#f3f4f8] col-span-3 pt-11 flex flex-col justify-between">
        <div>
          <h3 className="mega-menu-featured-content-title mb-4">Popular Articles</h3>
          {isLoading ? (
            <div className="flex flex-col gap-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex gap-3 animate-pulse">
                  <div className="w-[132px] h-[100px] bg-gray-300 rounded"></div>
                  <div className="flex-1">
                    <div className="h-4 bg-gray-300 rounded mb-2"></div>
                    <div className="h-3 bg-gray-300 rounded mb-1"></div>
                    <div className="h-3 bg-gray-300 rounded w-2/3"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : popularBlogs && popularBlogs.data && popularBlogs.data.length > 0 ? (
            <div className="flex flex-col gap-4">
              {popularBlogs.data.map((article) => (
                <ArticleItem
                  key={article.article_id}
                  title={article.article_title}
                  text={article.article_description}
                  image={article.article_image_featured_landscape || 'https://placehold.co/132x100'}
                  hrefUrl={`/professionals/news/insight-blog/${article.article_slug}`}
                />
              ))}
            </div>
          ) : (
            <div className="text-gray-500 text-sm">No popular articles available</div>
          )}
        </div>
      </div>
    </div>
  );
};
